document.addEventListener("DOMContentLoaded", (duration) => {
    const stats = document.querySelectorAll(".ticker .stat h2");
    let hasRun = false;
    
    function animateCount(el, delay = 0) {
        const original = el.textContent.trim();
        
        const prefix = original.includes("$") ? "$" : "";
        const suffix = original.includes("+") ? "+" : "";
        
        const target = parseInt(original.replace(/[^\d]/g, ""), 10);
        let current = 0;
        
        const duration = 2250;
        const startTime = performance.now() + delay;
        
        function easeOutQuad(t) {
            return t * (2 - t);
    }

    function update(now) {
      if (now < startTime) {
        requestAnimationFrame(update);
        return;
      }

      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOutQuad(progress);

      current = Math.floor(eased * target);
      el.textContent = `${prefix}${current}${suffix}`;

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        el.textContent = `${prefix}${target}${suffix}`;
      }
    }

    requestAnimationFrame(update);
  }

  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting && !hasRun) {
        hasRun = true;

        stats.forEach((stat, index) => {
          animateCount(stat, index * 50); // Stagger time
        });

        observer.disconnect();
      }
    },
    { threshold: 0.4}
  );

  const ticker = document.querySelector(".ticker");
  if (ticker) observer.observe(ticker);
});
